module.exports = __webpack_public_path__ + "5b0e2011de161109c5e7484c08013b61.MP3";